import { Component, input } from '@angular/core';
import { FormFieldAddon } from '../../form-field.interface';
import { FormFieldAddonDetailsComponent } from '../form-field-addon-details/form-field-addon-details.component';

@Component({
  selector: 'ui-form-field-addon',
  templateUrl: './form-field-addon.component.html',
  styleUrls: ['./form-field-addon.component.scss'],
  standalone: true,
  imports: [FormFieldAddonDetailsComponent],
})
export class FormFieldAddonComponent {
  readonly innerContent = input<FormFieldAddon>();
  readonly outerContent = input<FormFieldAddon>();
  readonly position = input<'start' | 'end'>('start');
}
